import React, { useEffect, useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import ProductSection from './components/ProductSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';
import CallMeDialog from './register';
import img1 from './images/kits/k1.jpeg';
import img2 from './images/kits/k2.jpeg';
import img3 from './images/kits/k3.jpeg';
import kit2 from './images/kits/kit2.jpg';
import { useNavigate, useParams } from 'react-router';
import axios from 'axios';
import { Product } from './types';
function Guide()
{
    return (    
    <div className="min-h-screen">
      <Header />      
      <main>        
        {/* Intro Section */}
        <section className="py-24 bg-black">
          <div className='container mt-7'>
                <div className='ms-5'>
                    <table className='table border-separate border-gray-300' width="60%" align="center">
                        <tbody>
                            <tr>
                                <td>Side Effects</td><td>No</td>
                            </tr>
                            <tr>
                                <td>Course Duration</td><td>1-2 Months</td>
                            </tr>
                            <tr>
                                <td>Results</td><td>Within 7 Days 100%</td>
                            </tr>
                            <tr>
                                <td>Ingredients</td><td>Ayurvedic Nutraceuticals pulse</td>
                            </tr>
                            <tr>
                                <td>Licensed by</td><td>FSSAI, Ayush Mantralaya, FDA, Make in India</td>
                            </tr>
                            <tr>
                                <td>Age criteria</td><td>Above 18 Only</td>
                            </tr>
                            <tr>
                                <td>Delivery</td><td>Delivery India/International, within 3-5 days</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </section>        
      </main>
      <Footer />
    </div>
  );  
}

export default Guide;
